// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Overlay_overlay__349vV","show":"Overlay_show__1aTR6","loader":"Overlay_loader__2Y4ol","dark":"Overlay_dark__3Lt0O","message":"Overlay_message__3a16_"};